import { first, last } from 'lodash';
import { dictionaryService } from '../../../dataFlow';
import { useDictionaryItem, useParameter } from '../../../shared'; 

export function useSlideSubtitle() {
  const [parameterValues] = useParameter<number[]>("@calendar_display");
  const [baseIndexValue] = useParameter<number>("@base_index_display");
  const [methodValue] = useParameter<number>("@method");
  const isMethodIndex = methodValue === 2;
  const [, calendarNameStart] = useDictionaryItem(dictionaryService, "calendar-origin", first(parameterValues));
  const [, calendarNameEnd] = useDictionaryItem(dictionaryService, "calendar-origin", last(parameterValues));
  const [, baseIndexName] = useDictionaryItem(dictionaryService, "calendar-origin", baseIndexValue);
  if ([baseIndexName, calendarNameStart, calendarNameEnd].some(x => !Boolean(x))) {
    return '';
  }
  const baseIndexTitle = `(Base 100 in ${baseIndexName})`;
  const subtitle = `${isMethodIndex ? baseIndexTitle : ''}`; 
  return subtitle;
}